// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","footer":"InfoBlockFooter_footer__2NiEh"};